// @flow

import React from 'react';
import TabTitle from './TabTitle';
import TabHeaderWrapper from './TabHeaderWrapper';
import { Container, Row } from '../';

type Props = {
  titles: Array,
  tabIndex: Number,
  setIndex: Function,
  borderColor: String,
  color?: String,
  disabled?: Boolean,
};

export default function TabHeader({
  titles,
  tabIndex,
  setIndex,
  borderColor,
  color,
  disabled,
}: Props) {
  return (
    <TabHeaderWrapper
      borderColor={borderColor}
      className="w-100 py-1 d-flex flex-column flex-sm-row align-items-center justify-content-between user-select-none"
    >
      <div className="container">
        <Row>
          {titles.map((title, index) => (
            <TabTitle
              color={color}
              key={index}
              iconName={title.iconName}
              text={title.text}
              active={tabIndex === index}
              onClick={() => setIndex(index)}
              disabled={disabled && index > tabIndex}
            />
          ))}
        </Row>
      </div>
    </TabHeaderWrapper>
  );
}
